// Dataset Actions
import { setValue, updateObjectValue } from './generalStoreActions';
import * as libCon from '../../community-hats-js-library/Constants.js';
import * as air_fun from '../../community-hats-js-library/back-end/router';
import { showError } from '../../utils/generalFunctions.js';

export const setAllDatasetsToLoading = () => {
  setValue(libCon.STATUS_DATASET_PARTICIPANTS, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_SENSORS, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_SENSOR_HOUSE_PLACEMENT, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_HOUSES, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_EMAILS, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_PARTICIPANT_PLACEMENT, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_WEARABLES, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_WEARABLE_PLACEMENT, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_PHONES, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_PHONE_PLACEMENT, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_RECEIVED_SENSOR_FILES, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_ISSUES, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_COLLECTION_RECORDS, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_COVERAGE_SUMMARY, libCon.LOADING);
  setValue(libCon.STATUS_DATASET_BATTERY_CHANGE_RECORDS, libCon.LOADING);
};

export const fetchParticipantData = async () => {
  fetchData(libCon.STATUS_DATASET_PARTICIPANTS, libCon.DATASET_PARTICIPANTS, air_fun.getAllParticipants);
};

export const fetchSensorData = async () => {
  fetchData(libCon.STATUS_DATASET_SENSORS, libCon.DATASET_SENSORS, air_fun.getAllSensors);
};

export const fetchSensorHousePlacementData = async () => {
  fetchData(
    libCon.STATUS_DATASET_SENSOR_HOUSE_PLACEMENT,
    libCon.DATASET_SENSOR_HOUSE_PLACEMENT,
    air_fun.getAllSensorHousePlacement
  );
};

export const fetchHouseData = async () => {
  fetchData(libCon.STATUS_DATASET_HOUSES, libCon.DATASET_HOUSES, air_fun.getAllHouses);
};

export const fetchEmailData = async () => {
  fetchData(libCon.STATUS_DATASET_EMAILS, libCon.DATASET_EMAILS, air_fun.getAllEmails);
};

export const fetchParticipantPlacementData = async () => {
  fetchData(
    libCon.STATUS_DATASET_PARTICIPANT_PLACEMENT,
    libCon.DATASET_PARTICIPANT_PLACEMENT,
    air_fun.getAllParticipantPlacement
  );
};

export const fetchWearableData = async () => {
  fetchData(libCon.STATUS_DATASET_WEARABLES, libCon.DATASET_WEARABLES, air_fun.getAllWearables);
};

export const fetchWearablePlacementData = async () => {
  fetchData(
    libCon.STATUS_DATASET_WEARABLE_PLACEMENT,
    libCon.DATASET_WEARABLE_PLACEMENT,
    air_fun.getAllWearablePlacements
  );
};

export const fetchPhoneData = async () => {
  fetchData(libCon.STATUS_DATASET_PHONES, libCon.DATASET_PHONES, air_fun.getAllPhones);
};

export const fetchPhonePlacementData = async () => {
  fetchData(libCon.STATUS_DATASET_PHONE_PLACEMENT, libCon.DATASET_PHONE_PLACEMENT, air_fun.getAllPhonesPlacement);
};

export const fetchReceivedSensorFiles = async () => {
  fetchData(
    libCon.STATUS_DATASET_RECEIVED_SENSOR_FILES,
    libCon.DATASET_RECEIVED_SENSOR_FILES,
    air_fun.getAllReceivedSensorFiles
  );
};

export const fetchActionItems = async () => {
  fetchData(libCon.STATUS_DATASET_ISSUES, libCon.DATASET_ISSUES, air_fun.getAllIssues);
};

export const fetchCollectionRecords = async () => {
  fetchData(
    libCon.STATUS_DATASET_COLLECTION_RECORDS,
    libCon.DATASET_COLLECTION_RECORDS,
    air_fun.getAllCollectionRecords
  );
};

export const fetchGoveeActivationCodes = async () => {
  fetchData(
    libCon.STATUS_DATASET_GOVEE_ACTIVATION_CODES,
    libCon.DATASET_GOVEE_ACTIVATION_CODES,
    air_fun.getAllGoveeActivationCodes
  );
};

export const fetchBatteryChangeRecordsCodes = async () => {
  fetchData(
    libCon.STATUS_DATASET_BATTERY_CHANGE_RECORDS,
    libCon.DATASET_BATTERY_CHANGE_RECORDS,
    air_fun.getAllBatteryChangeRecords
  );
};

export const fetchCoverageSummary = async () => {
  setValue(libCon.STATUS_DATASET_COVERAGE_SUMMARY, libCon.LOADING);

  const [status, response] = await air_fun.getCoverageSummaryFromBucket();

  try {
    const coverage = JSON.parse(response);

    if (status === libCon.OK) {
      setValue(libCon.DATASET_COVERAGE_SUMMARY, coverage);
      setValue(libCon.STATUS_DATASET_COVERAGE_SUMMARY, libCon.OK);
    } else setValue(libCon.STATUS_DATASET_COVERAGE_SUMMARY, libCon.ERROR);
  } catch (error) {
    console.log(error);
    setValue(libCon.STATUS_DATASET_COVERAGE_SUMMARY, libCon.ERROR);
  }
};

export const fetchData = async (status_id, dataset_id, extractionMethod) => {
  setValue(status_id, libCon.LOADING);

  try {
    const [status, records] = await extractionMethod();

    if (status === libCon.OK) {
      setValue(dataset_id, records);
      setValue(status_id, libCon.OK);
    } else setValue(status_id, libCon.ERROR);
  } catch (error) {
    console.log(error);
    setValue(status_id, libCon.ERROR);
  }
};

export const updateSinglePhone = async (serial) => {
  try {
    let [status, newRecords] = await air_fun.getPhoneBySerial(serial);

    if (status === libCon.OK) {
      updateObjectValue(libCon.DATASET_PHONES, newRecords);

      return newRecords;
    } else showError(status);
  } catch (error) {
    console.log(error);
    showError(error);
  }
};

export const updateSingleAirtableObject = async (internalId, getFun, datasetId) => {
  try {
    let [status, newRecords] = await getFun(internalId);

    if (status === libCon.OK) {
      updateObjectValue(datasetId, newRecords);

      return [status, newRecords[internalId]];
    } else {
      showError(status);
      return [status, null];
    }
  } catch (error) {
    console.log(error);
    showError(error);
    return [libCon.STATUS_ERROR, null];
  }
};

export const updateSingleParticipant = async (internalId) => {
  return await updateSingleAirtableObject(internalId, air_fun.getParticipant, libCon.DATASET_PARTICIPANTS);
};

export const updateSingleHouse = async (internalId) => {
  return await updateSingleAirtableObject(internalId, air_fun.getHouse, libCon.DATASET_HOUSES);
};

export const updateSingleWerablePlacements = async (internalId) => {
  return await updateSingleAirtableObject(internalId, air_fun.getWearablePlacement, libCon.DATASET_WEARABLE_PLACEMENT);
};

export const updateSingleEmail = async (internalId) => {
  return await updateSingleAirtableObject(internalId, air_fun.getEmail, libCon.DATASET_EMAILS);
};

export const updateSingleSensorFiles = async (serial) => {
  try {
    // Update received sensor files
    let [recordStatus, newRecords] = await air_fun.getReceivedSensorFilesBySerial(serial);

    if (recordStatus !== libCon.OK) {
      showError(recordStatus);
      return;
    }

    updateObjectValue(libCon.DATASET_RECEIVED_SENSOR_FILES, newRecords);
    // Update sensor
    let [sensorStatus, newSensorRecord] = await air_fun.getSensorBySerial(serial);

    if (sensorStatus !== libCon.OK) {
      showError(sensorStatus);
      return;
    }

    updateObjectValue(libCon.DATASET_SENSORS, newSensorRecord);

    return newRecords;
  } catch (error) {
    console.log(error);
  }
};

export const logBatteryChange = async (sensorId, serial, date, time) => {
  try {
    // Update received sensor files
    let [status, records] = await air_fun.logBatteryChange(sensorId, serial, date, time);

    if (status === libCon.OK) updateObjectValue(libCon.DATASET_SENSORS, records);

    return status;
  } catch (error) {
    console.log(error);
    return libCon.ERROR;
  }
};

export const markActionItemAsDone = async (actionItem, noteText) => {
  try {
    // Update received sensor files
    let [status, records] = await air_fun.markIssueAsDone(actionItem, noteText);

    if (status === libCon.OK) updateObjectValue(libCon.DATASET_ISSUES, records);

    return status;
  } catch (error) {
    console.log(error);
    return libCon.ERROR;
  }
};

export const markActionItemAsReadyForRevision = async (actionItem, noteText) => {
  try {
    // Update received sensor files
    let [status, records] = await air_fun.markIssueAsReadyForRevision(actionItem, noteText, libCon.DASHBOARD);

    if (status === libCon.OK) updateObjectValue(libCon.DATASET_ISSUES, records);

    return status;
  } catch (error) {
    console.log(error);
    return libCon.ERROR;
  }
};

export const addNoteToActionItem = async (actionItem, noteText) => {
  try {
    // Update received sensor files
    let [status, records] = await air_fun.addNoteToIssue(actionItem, noteText, libCon.DASHBOARD);

    if (status === libCon.OK) updateObjectValue(libCon.DATASET_ISSUES, records);

    return status;
  } catch (error) {
    console.log(error);
    return libCon.ERROR;
  }
};
